import gql from 'graphql-tag';

export default gql`
  mutation setFutureLogGroup($productId: Int!, $isFutureLog: Boolean!) {
    setFutureLogGroup(productId: $productId, isFutureLog: $isFutureLog) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
